import styled from 'styled-components';
import { layout } from '@prisjakt/ui-base';

const IMAGE_MAX_SIZE = 64;

export const ProductAlertInfo = styled.div`
  display: grid;
  grid-template-columns: ${IMAGE_MAX_SIZE}px 1fr auto;
  column-gap: ${layout.measurements.spacing050};
  align-items: center;
`;

export const ProductInfoName = styled.div`
  flex-grow: 1;
  margin: 0 1rem;

  h2 {
    font-size: 1rem;
    font-weight: normal;
    margin-bottom: 0.25rem;
  }
`;

export const ProductInfoImage = styled.img`
  min-width: 40px;
`;
